const featureFlags = {
  dashboard: true,
  history: true,
  refundHistory: true,
  withdrawal: true,
  topupBalance: true,
  widrawalRequest: true,
  transfers: true,
  cashbox: true,
  massTransfers: true,
  saleCreation: true,
  sales: true,
  portfolio: true,
  myFees: true,
  limits: true,
  exchange: true,
  contracts: true,
  trade: true,
  verification: true,
  settings: true,
  requests: true,
  tokens: true,
  tfa: true
}

export default Object.assign(
  {
    HORIZON_SERVER: process.env.HORIZON_SERVER,
    USDT_LISTENER_SERVER: process.env.USDT_LISTENER_SERVER,
    API_MOC_DATA: process.env.API_MOC_DATA,
    FILE_STORAGE: process.env.FILE_STORAGE,
    TRANSACTIONS_PER_PAGE: 12,
    REQUESTS_PER_PAGE: 10,
    DECIMAL_POINTS: 6,
    MINIMAL_NUMBER_INPUT_STEP: 0.000001,
    VALIDATE_EMAILS: process.env.NODE_ENV === 'production',
    AIRDROP_REGISTRATION_END: new Date('2018-02-25T12:00:00'),
    FEATURE_FLAGS: featureFlags,
    NULL_ASSET_SIGNER: 'GAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHV4',
    LOCAL_STORAGE_KEY: 'tokend-client',
    DEFAULT_QUOTE_ASSET: 'EUR',
    AVAILABLE_QUOTE_ASSETS: ['USD', 'UAH', 'EUR'],
    AVAILABLE_INVEST_ASSETS: ['USD', 'UAH', 'EUR'],
    SALE_PERIOD_VARIANTS: ['month', 'quarter', 'half-year', 'year'],
    AVAILABLE_FUND_TYPES: ['crowdfunding', 'deposit', 'equity'],
    DEFAULT_FUND_TYPE: 'crowdfunding',
    INVOICE_ASSET: 'TAU',
    DEFAULT_TRADE_PAIRS_RE: [
      // Descending priority
      /BTC.*\/.*ETH/,
      /ETH.*\/.*BTC/
    ]
  },
  process.env,
  document.ENV
)



// WEBPACK FOOTER //
// ./src/config.js